import useAppModal from 'hooks/useAppModal';
import { PropertyOwnerPermissionType } from 'models/Owner';
import { useParams } from 'react-router-dom';
import useOwnerMutations, {
  OwnerPayload,
} from '../ownerModal/useOwnerMutation';
import { TableItemOwner } from '../../PropertySettingsOwnersTab.types';
import OwnerPermissionsModal, {
  ownerPermissionsModalId,
} from './OwnerPermissionsModal';
import { OwnerPermissionsFormSchemaType } from './OwnerPermissionsModal.schema';

const useOwnerPermissionsModal = () => {
  const { openModal, closeModal } = useAppModal();
  const { createOrUpdateOwner } = useOwnerMutations();
  const { uid: propertyUid } = useParams();

  const successCallback = () => {
    closeModal(ownerPermissionsModalId);
  };

  const handleSubmit = (values: OwnerPermissionsFormSchemaType) => {
    const permissionTypes = Object.entries(values)
      .filter(([, value]) => value === true)
      .map(([key]) => key as PropertyOwnerPermissionType);

    const owner: OwnerPayload['owner'] = {
      uid: values?.uid,
      permissionTypes,
      formula: values?.formula,
    };

    const payload = {
      owner,
      propertyUid: propertyUid as string,
    } satisfies OwnerPayload;

    return createOrUpdateOwner({
      propertyUid: propertyUid as string,
      payload,
      successCallback,
    });
  };

  const openPermissionsModal = (owner: TableItemOwner) => {
    openModal({
      id: ownerPermissionsModalId,
      customContent: (
        <OwnerPermissionsModal onSubmit={handleSubmit} owner={owner} />
      ),
    });
  };

  return {
    openPermissionsModal,
  };
};

export default useOwnerPermissionsModal;
